var _defs, _path, _path2, _ellipse, _path3, _path4, _rect, _rect2, _path5, _path6, _rect3, _rect4, _path7, _ellipse2, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _g5, _g6, _path19, _path20, _path21, _g7, _g8, _path22, _path23, _path24, _path25, _path26, _g9, _g0, _g1, _g10, _path27, _path28, _path29, _g11, _g12, _path30, _g13, _path31, _path32, _g14, _g15, _g16, _path33, _g17, _g18, _path34, _g19, _path35, _g20, _path36, _g21, _g22, _rect5, _g23, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 35.646,
    viewBox: "0 0 47 35.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0edca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdcad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdcad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#bdcad3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#bfe3cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0edca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 25.59,
    y1: 1,
    x2: 25.59,
    y2: 0,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 20.352,
    y1: 0.5,
    x2: 21.352,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 32.049,
    y1: 0.5,
    x2: 33.049,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.406,
    y1: 0.5,
    x2: -3.796,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f8bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -5.51,
    y1: 1,
    x2: -5.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5851b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#5249a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#433787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e1c5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#efaba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#d6a1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c298d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#b292ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a78ef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#a08bfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f8bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0,
    x2: 1,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f8bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dcc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#dddac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#b3c9b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#8ebbaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#71b0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#5aa798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#4aa093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#409d90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e9c8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e1c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#2f1e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#35256b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#3e317e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#4c4198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5851b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M3816.8,1955.587h-1.461a2.946,2.946,0,0,1,0-5.832h1.461a2.946,2.946,0,0,0,0,5.832Z",
    transform: "translate(-3812.811 -1949.755)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M2973.449,1955.587h-1.46a2.946,2.946,0,0,1,0-5.832h1.46a2.946,2.946,0,0,0,0,5.832Z",
    transform: "translate(-2969.463 -1949.755)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Car_0",
    "data-name": "Car 0",
    transform: "translate(48.41 -219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ev_station",
    "data-name": "ev station",
    transform: "translate(-30.625 219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(6.923 15.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(3.109 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(0.031)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M2483.3,1570.362h-1.814v-6.744a.335.335,0,0,1,.335-.335h0a2.419,2.419,0,0,1,1.479,2.124Z",
    transform: "translate(-2481.309 -1563.155)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M2483,1604.372c-.386-.02-.992-.637-1.354-1.378a3.243,3.243,0,0,1-.158-.383v6.523h1.814v-4.955c0-.039,0-.079,0-.118C2483.278,1604.262,2483.179,1604.381,2483,1604.372Z",
    transform: "translate(-2481.311 -1601.926)",
    fill: "url(#linear-gradient-2)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.476,
    cy: 1.239,
    rx: 0.476,
    ry: 1.239,
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 0.546)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M2510.125,1624.565h-.8l-.173-.253h.8Z",
    transform: "translate(-2508.583 -1623.321)",
    fill: "#3cf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M2592.83,1719.435v4.764H2593v-4.874A.235.235,0,0,1,2592.83,1719.435Z",
    transform: "translate(-2591.077 -1716.992)",
    fill: "#58595b",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M2500.442,1644.348v5.933h.628v-5.112A3.614,3.614,0,0,1,2500.442,1644.348Z",
    transform: "translate(-2499.995 -1643.074)",
    fill: "#fff",
    opacity: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 2.237,
    height: 0.622,
    transform: "translate(0 6.9)",
    fill: "url(#linear-gradient-3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 1.445,
    height: 0.622,
    transform: "translate(0.792 6.9)",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0 0.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(0.212)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M2261.639,1570.362h1.814v-6.744a.334.334,0,0,0-.335-.335h0a2.419,2.419,0,0,0-1.479,2.124Z",
    transform: "translate(-2261.639 -1563.284)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M2277.746,1586.549a2.925,2.925,0,0,0-.677.9v5.854h.677Z",
    transform: "translate(-2276.851 -1586.22)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M2363.888,1563.355a.335.335,0,0,0-.2-.07l-.038,0v7.075h.242Z",
    transform: "translate(-2362.204 -1563.285)",
    fill: "#58595b",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 2.237,
    height: 0.622,
    transform: "translate(2.237 7.394) rotate(180)",
    fill: "url(#linear-gradient-6)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 1.445,
    height: 0.622,
    transform: "translate(1.445 7.394) rotate(180)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(18.125 5.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M3039.312,874.411h3.6l4.826-17.49h-4.821Z",
    transform: "translate(-3039.312 -856.921)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M3041.279,874.411h-1.967l3.607-17.49h2.45Z",
    transform: "translate(-3039.312 -856.921)",
    fillRule: "evenodd",
    opacity: 0.8,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M3244.3,856.92h4.821l-.965,3.5-2.062-.69-2.515.69Z",
    transform: "translate(-3240.689 -856.92)",
    fill: "#939598",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M3209.965,856.921h-2.45l-1.248,6.052,2.429-.628Z",
    transform: "translate(-3203.907 -856.921)",
    fill: "#58595b",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 14.607,
    cy: 0.233,
    rx: 14.607,
    ry: 0.233,
    transform: "translate(0 23.933)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(1.11 23.135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 26.989,
    height: 1.031,
    transform: "translate(26.989 1.031) rotate(180)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 20.721,
    height: 1.031,
    transform: "translate(26.989 1.031) rotate(180)",
    fill: "url(#linear-gradient-11)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M1785.654,618.147h-29c0-1.708,6.62-3.093,19.129-3.093h7.9c1.086,0,1.967,1.385,1.967,3.093Z",
    transform: "translate(-1756.655 -612.476)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-12)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    d: "M0,0H29a0,0,0,0,1,0,0V0a.918.918,0,0,1-.918.918H.918A.918.918,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 5.671)",
    fill: "url(#linear-gradient-12)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M2368.385,661.529h-5.393c-8.536,0-13.053.97-13.053,2.167h0c0,.355.179.643.4.643h18.993c.219,0,.4-.288.4-.643h0C2369.728,662.5,2369.127,661.529,2368.385,661.529Z",
    transform: "translate(-2341.556 -658.294)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 26.989,
    height: 0.374,
    transform: "translate(28.098 24.166) rotate(180)",
    fill: "#669da8",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M2369.348,664.527h-18.993c-.318,0-.568-.357-.568-.813,0-.717,1.166-1.289,3.466-1.7a59.481,59.481,0,0,1,9.758-.637h5.394c.848,0,1.512,1.027,1.512,2.337C2369.916,664.17,2369.667,664.527,2369.348,664.527Zm-6.338-2.81a59.165,59.165,0,0,0-9.7.632c-2.956.528-3.186,1.178-3.186,1.365,0,.288.136.473.228.473h18.993c.093,0,.228-.184.228-.473,0-1.083-.537-2-1.172-2Z",
    transform: "translate(-2341.406 -658.144)",
    fill: "#939598",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M2357.464,652.642h-18.993c-.319,0-.569-.357-.569-.813,0-.717,1.167-1.289,3.467-1.7a59.5,59.5,0,0,1,9.757-.637h5.394c.848,0,1.513,1.027,1.513,2.337C2358.032,652.285,2357.783,652.642,2357.464,652.642Zm-6.338-2.81a59.2,59.2,0,0,0-9.7.632c-2.956.528-3.185,1.178-3.185,1.365,0,.289.135.473.228.473h18.993c.093,0,.228-.184.228-.473,0-1.083-.537-2-1.172-2Z",
    transform: "translate(-2329.688 -646.427)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M3117.238,616.46a3.967,3.967,0,0,0-.25-1.39,1.289,1.289,0,0,0-.2-.016h-2.106a2.6,2.6,0,0,1,.333,1.279,2.524,2.524,0,0,1-1.762,2.434l1.534-2.505a.162.162,0,0,0-.138-.246h0a.154.154,0,0,0-.017-.045.159.159,0,0,0-.14-.083h-.235l.41-.833h-2.653l-.391,1.8a.157.157,0,0,0,.031.136.163.163,0,0,0,.126.06h0a.169.169,0,0,0,.032.068.162.162,0,0,0,.121.06l-.214.982a2.609,2.609,0,0,1-.218-3.1h-2.426a3.956,3.956,0,0,0-.211,1.279,3.914,3.914,0,0,0,1.1,2.732h6.3A3.919,3.919,0,0,0,3117.238,616.46Z",
    transform: "translate(-3089.753 -612.475)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-15)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(19.593)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M3150.022,433.459a6.744,6.744,0,0,0-3.116-.86,3.8,3.8,0,0,0-3.719,3.857,3.9,3.9,0,0,0,1.544,3.125,3.6,3.6,0,0,0,2.729.838,3.577,3.577,0,0,0,.387.022,3.794,3.794,0,0,0,3.719-3.857A3.9,3.9,0,0,0,3150.022,433.459Zm-4.608,3.125a2.55,2.55,0,0,1,1.069-2.1l-.542,2.487a.162.162,0,0,0,.158.2h0a.172.172,0,0,0,.032.068.162.162,0,0,0,.12.06l-.214.982A2.59,2.59,0,0,1,3145.414,436.585Zm3.7-.2a.161.161,0,0,0-.137-.246h0a.148.148,0,0,0-.016-.045.16.16,0,0,0-.141-.083h-.236l.419-.853a2.6,2.6,0,0,1,.344,1.3,2.524,2.524,0,0,1-1.761,2.434Z",
    transform: "translate(-3143.187 -432.6)",
    fill: "url(#linear-gradient-16)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M3213.3,444.043a3.7,3.7,0,1,0,3.558,3.695A3.628,3.628,0,0,0,3213.3,444.043Zm-2.594,3.695a2.65,2.65,0,0,1,2.5-2.692l-.708,3.245h.385l-.434,1.991A2.69,2.69,0,0,1,3210.707,447.738Zm2.594,2.695a2.511,2.511,0,0,1-.646-.084l1.772-2.894h-.72l.981-1.993a2.717,2.717,0,0,1,1.208,2.277A2.646,2.646,0,0,1,3213.3,450.432Z",
    transform: "translate(-3208.804 -443.881)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M3213.463,449.376a3.859,3.859,0,1,1,3.719-3.857A3.794,3.794,0,0,1,3213.463,449.376Zm0-7.39a3.536,3.536,0,1,0,3.4,3.533A3.47,3.47,0,0,0,3213.463,441.986Zm0,6.39a2.675,2.675,0,0,1-.687-.09c-.042-.011-.182-.056-.223-.071a2.854,2.854,0,0,1-1.845-2.7,2.8,2.8,0,0,1,2.649-2.854.165.165,0,0,1,.131.058.16.16,0,0,1,.034.138l-.663,3.048h.184a.161.161,0,0,1,.158.2l-.368,1.692,1.47-2.4h-.431a.162.162,0,0,1-.146-.233l.98-1.993a.162.162,0,0,1,.1-.085.164.164,0,0,1,.132.021,2.871,2.871,0,0,1,1.28,2.412A2.811,2.811,0,0,1,3213.463,448.376Zm-.389-.356a2.372,2.372,0,0,0,.389.032,2.487,2.487,0,0,0,2.433-2.533,2.557,2.557,0,0,0-.985-2.035l-.782,1.59h.46a.162.162,0,0,1,.138.246Zm.084-5.013a2.49,2.49,0,0,0-2.127,2.513,2.542,2.542,0,0,0,1.459,2.322l.351-1.607h-.183a.162.162,0,0,1-.159-.2Z",
    transform: "translate(-3208.804 -441.535)",
    fill: "#939598",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M3202.021,440.313a3.859,3.859,0,1,1,3.719-3.857A3.794,3.794,0,0,1,3202.021,440.313Zm0-7.39a3.536,3.536,0,1,0,3.4,3.533A3.47,3.47,0,0,0,3202.021,432.923Zm0,6.39a2.67,2.67,0,0,1-.687-.09c-.043-.011-.183-.056-.223-.071a2.855,2.855,0,0,1-1.845-2.7,2.8,2.8,0,0,1,2.649-2.854.162.162,0,0,1,.165.2l-.664,3.048h.183a.161.161,0,0,1,.158.2l-.368,1.691,1.469-2.4h-.431a.162.162,0,0,1-.145-.233l.981-1.993a.162.162,0,0,1,.234-.064,2.87,2.87,0,0,1,1.28,2.412A2.811,2.811,0,0,1,3202.021,439.313Zm-.388-.356a2.353,2.353,0,0,0,.388.032,2.487,2.487,0,0,0,2.433-2.533,2.556,2.556,0,0,0-.985-2.035l-.781,1.589h.459a.162.162,0,0,1,.138.246Zm.084-5.013a2.49,2.49,0,0,0-2.128,2.513,2.542,2.542,0,0,0,1.46,2.322l.35-1.607h-.184a.161.161,0,0,1-.125-.06.163.163,0,0,1-.033-.136Z",
    transform: "translate(-3197.524 -432.6)",
    fill: "#f1f2f2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(-48.41 239.362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 23.5,
    cy: 0.232,
    rx: 23.5,
    ry: 0.232,
    transform: "translate(0 14.82)",
    fill: "#231f20",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(4.039 9.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M4252.926,1952.67a2.741,2.741,0,0,1,2.524-2.915h-1.46a2.946,2.946,0,0,0,0,5.832h1.46A2.742,2.742,0,0,1,4252.926,1952.67Z",
    transform: "translate(-4251.463 -1949.755)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(1.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M4157.942,1949.755a2.938,2.938,0,1,1-2.582,2.915A2.764,2.764,0,0,1,4157.942,1949.755Z",
    transform: "translate(-4155.36 -1949.755)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(1.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M4157.887,1949.755a2.946,2.946,0,1,1-2.526,2.915A2.741,2.741,0,0,1,4157.887,1949.755Z",
    transform: "translate(-4155.36 -1949.755)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(22.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M3409.575,1952.67a2.742,2.742,0,0,1,2.526-2.915h-1.46a2.946,2.946,0,0,0,0,5.832h1.46A2.743,2.743,0,0,1,3409.575,1952.67Z",
    transform: "translate(-3408.115 -1949.755)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(1.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M3314.595,1949.755a2.938,2.938,0,1,1-2.582,2.915A2.763,2.763,0,0,1,3314.595,1949.755Z",
    transform: "translate(-3312.013 -1949.755)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(1.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M3314.539,1949.755a2.946,2.946,0,1,1-2.525,2.915A2.741,2.741,0,0,1,3314.539,1949.755Z",
    transform: "translate(-3312.013 -1949.755)"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M2808.028,1881.874h30.361a2.5,2.5,0,0,1,2.5,2.5v2.2c0,.211-.255,1.05-1,1.05h-39.863a3.037,3.037,0,0,1-1.04-.184l-1.39-.564a2.041,2.041,0,0,1-1.271-1.892v-3.11Z",
    transform: "translate(-2794.624 -1874.438)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(15.565 9.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(0)",
    style: {
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M3816.8,1955.587h-1.461a2.946,2.946,0,0,1,0-5.832h1.461a2.946,2.946,0,0,0,0,5.832Z",
    transform: "translate(-3812.811 -1949.755)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    style: {
      isolation: "isolate"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M3814.272,2043.648a3.486,3.486,0,0,1,.031-.461h-1.46a3.4,3.4,0,0,0-.032.461,2.742,2.742,0,0,0,2.525,2.916h1.461A2.742,2.742,0,0,1,3814.272,2043.648Z",
    transform: "translate(-3812.811 -2040.732)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M3886.536,1988.756a3.016,3.016,0,0,0-.441.861,3.251,3.251,0,0,0-.13.569h1.46a3.208,3.208,0,0,1,.13-.569h0a3,3,0,0,1,.44-.861Z",
    transform: "translate(-3885.933 -1987.731)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M3867.892,1969.4a2.717,2.717,0,0,0-.487.509h1.461a2.7,2.7,0,0,1,.487-.509Z",
    transform: "translate(-3866.801 -1968.883)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M3815.706,1949.755h-1.459a2.29,2.29,0,0,0-1.435.516h1.461A2.288,2.288,0,0,1,3815.706,1949.755Z",
    transform: "translate(-3811.721 -1949.755)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(1.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M3719.292,1949.755a2.938,2.938,0,1,1-2.582,2.915A2.764,2.764,0,0,1,3719.292,1949.755Z",
    transform: "translate(-3716.71 -1949.755)",
    fill: "#939598"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(1.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M3719.234,1949.755a2.947,2.947,0,1,1-2.524,2.915A2.741,2.741,0,0,1,3719.234,1949.755Z",
    transform: "translate(-3716.71 -1949.755)",
    fill: "#414042"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(2.108 0.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M3743.218,1978.2a2.191,2.191,0,1,1-1.878,2.168A2.039,2.039,0,0,1,3743.218,1978.2Z",
    transform: "translate(-3741.339 -1978.196)",
    fill: "#231f20"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(2.32 0.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M3751.073,1987.515a1.944,1.944,0,1,1-1.665,1.924A1.809,1.809,0,0,1,3751.073,1987.515Z",
    transform: "translate(-3749.408 -1987.515)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M3749.529,1987.515c-.041,0-.081,0-.121.007a1.962,1.962,0,0,1,0,3.834c.04,0,.08.007.121.007a1.944,1.944,0,0,0,0-3.848Z",
    transform: "translate(-3745.544 -1986.523)",
    fill: "#6d6e71",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M3750.215,1986.587a1.752,1.752,0,1,1-1.734-2A1.883,1.883,0,0,1,3750.215,1986.587Zm-1.384-.447a.616.616,0,0,1,.121.186l1.126.125a2.066,2.066,0,0,0-.195-.761Zm.194-1.293-.56,1.136.016,0a.458.458,0,0,1,.179.039l.945-.752A1.584,1.584,0,0,0,3749.024,1984.847Zm-1.112.01.2,1.3a.537.537,0,0,1,.154-.119l.309-1.292c-.033,0-.066-.006-.1-.006A1.416,1.416,0,0,0,3747.912,1984.857Zm-.828.821.878.841a.659.659,0,0,1,.044-.186l-.485-1.228A1.8,1.8,0,0,0,3747.084,1985.679Zm-.182,1.221,1.128-.008a.644.644,0,0,1-.059-.165l-1.048-.576a2.132,2.132,0,0,0-.047.436A2.058,2.058,0,0,0,3746.9,1986.9Zm.517,1.073.85-.833a.521.521,0,0,1-.128-.095l-1.109.332A1.867,1.867,0,0,0,3747.419,1987.972Zm1.18-.8a.462.462,0,0,1-.119.017.306.306,0,0,1-.042-.005l-.656,1.065a1.422,1.422,0,0,0,.632.183Zm.853.883-.559-1.1a.543.543,0,0,1-.13.14l.088,1.291A1.5,1.5,0,0,0,3749.452,1988.057Zm.6-1.082-1.048-.432c0,.015,0,.029,0,.044a.677.677,0,0,1-.024.177l.788.925A1.992,1.992,0,0,0,3750.048,1986.975Z",
    transform: "translate(-3744.493 -1983.669)",
    fill: "#e6e7e8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M3748.2,1984.107a1.808,1.808,0,1,1-1.789-2.068A1.944,1.944,0,0,1,3748.2,1984.107Zm-.125,0a1.681,1.681,0,1,0-1.664,1.923A1.807,1.807,0,0,0,3748.072,1984.107Z",
    transform: "translate(-3742.42 -1981.191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(3.437 2.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M3792.529,2036.658a.6.6,0,0,1,.548.633c0,.35-.245,1.193-.548,1.193s-.548-.843-.548-1.193A.6.6,0,0,1,3792.529,2036.658Z",
    transform: "translate(-3791.981 -2036.658)",
    fill: "#939598"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M3792.529,2036.658a.639.639,0,1,1-.548.633A.595.595,0,0,1,3792.529,2036.658Z",
    transform: "translate(-3791.981 -2036.658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(0.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M3783.633,2036.658a.639.639,0,1,1-.547.633A.6.6,0,0,1,3783.633,2036.658Z",
    transform: "translate(-3783.086 -2036.658)",
    fill: "#fff"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(3.892 2.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M3791.807,2046.352a.382.382,0,1,1-.328.378A.356.356,0,0,1,3791.807,2046.352Z",
    transform: "translate(-3791.48 -2046.352)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(37.726 9.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(0)",
    style: {
      isolation: "isolate"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M2973.449,1955.587h-1.46a2.946,2.946,0,0,1,0-5.832h1.46a2.946,2.946,0,0,0,0,5.832Z",
    transform: "translate(-2969.463 -1949.755)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    style: {
      isolation: "isolate"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M2970.923,2043.648a3.326,3.326,0,0,1,.033-.461h-1.461a3.365,3.365,0,0,0-.032.461,2.742,2.742,0,0,0,2.526,2.916h1.46A2.742,2.742,0,0,1,2970.923,2043.648Z",
    transform: "translate(-2969.463 -2040.732)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M3043.188,1988.756a3.035,3.035,0,0,0-.441.861,3.3,3.3,0,0,0-.13.569h1.461a3.273,3.273,0,0,1,.13-.569h0a3.041,3.041,0,0,1,.441-.861Z",
    transform: "translate(-3042.585 -1987.731)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M3024.543,1969.4a2.751,2.751,0,0,0-.488.509h1.46a2.751,2.751,0,0,1,.488-.509Z",
    transform: "translate(-3023.452 -1968.883)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M2972.358,1949.755h-1.46a2.291,2.291,0,0,0-1.435.516h1.461A2.289,2.289,0,0,1,2972.358,1949.755Z",
    transform: "translate(-2968.372 -1949.755)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(1.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M2875.944,1949.755a2.938,2.938,0,1,1-2.582,2.915A2.764,2.764,0,0,1,2875.944,1949.755Z",
    transform: "translate(-2873.362 -1949.755)",
    fill: "#939598"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(1.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M2875.888,1949.755a2.946,2.946,0,1,1-2.526,2.915A2.741,2.741,0,0,1,2875.888,1949.755Z",
    transform: "translate(-2873.362 -1949.755)",
    fill: "#414042"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(2.108 0.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M2899.869,1978.2a2.191,2.191,0,1,1-1.878,2.168A2.039,2.039,0,0,1,2899.869,1978.2Z",
    transform: "translate(-2897.991 -1978.196)",
    fill: "#231f20"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(2.32 0.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M2907.727,1987.515a1.944,1.944,0,1,1-1.667,1.924A1.809,1.809,0,0,1,2907.727,1987.515Z",
    transform: "translate(-2906.06 -1987.515)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M2906.182,1987.515c-.041,0-.08,0-.121.007a1.962,1.962,0,0,1,0,3.834c.041,0,.08.007.121.007a1.944,1.944,0,0,0,0-3.848Z",
    transform: "translate(-2902.195 -1986.523)",
    fill: "#6d6e71",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M2906.866,1986.587a1.752,1.752,0,1,1-1.734-2A1.883,1.883,0,0,1,2906.866,1986.587Zm-1.384-.447a.593.593,0,0,1,.12.186l1.127.125a2.052,2.052,0,0,0-.2-.761Zm.194-1.293-.561,1.136.017,0a.452.452,0,0,1,.179.039l.946-.752A1.59,1.59,0,0,0,2905.676,1984.847Zm-1.113.01.2,1.3a.541.541,0,0,1,.154-.119l.309-1.292c-.033,0-.066-.006-.1-.006A1.415,1.415,0,0,0,2904.564,1984.857Zm-.828.821.879.841a.693.693,0,0,1,.043-.186l-.485-1.228A1.827,1.827,0,0,0,2903.736,1985.679Zm-.182,1.221,1.128-.008a.652.652,0,0,1-.058-.165l-1.048-.576a2.051,2.051,0,0,0-.022.749Zm.518,1.073.85-.833a.516.516,0,0,1-.128-.095l-1.109.332A1.856,1.856,0,0,0,2904.072,1987.972Zm1.178-.8a.448.448,0,0,1-.118.017.3.3,0,0,1-.043-.005l-.656,1.065a1.422,1.422,0,0,0,.632.183Zm.853.883-.558-1.1a.573.573,0,0,1-.131.14l.089,1.291A1.5,1.5,0,0,0,2906.1,1988.057Zm.6-1.082-1.047-.432a.386.386,0,0,1,0,.044.687.687,0,0,1-.025.177l.787.925A1.966,1.966,0,0,0,2906.7,1986.975Z",
    transform: "translate(-2901.144 -1983.669)",
    fill: "#e6e7e8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M2904.85,1984.107a1.809,1.809,0,1,1-1.79-2.068A1.944,1.944,0,0,1,2904.85,1984.107Zm-.125,0a1.681,1.681,0,1,0-1.664,1.923A1.808,1.808,0,0,0,2904.725,1984.107Z",
    transform: "translate(-2899.072 -1981.191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(3.437 2.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M2949.181,2036.658a.6.6,0,0,1,.548.633c0,.35-.246,1.193-.548,1.193s-.548-.843-.548-1.193A.6.6,0,0,1,2949.181,2036.658Z",
    transform: "translate(-2948.633 -2036.658)",
    fill: "#939598"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M2949.181,2036.658a.639.639,0,1,1-.548.633A.6.6,0,0,1,2949.181,2036.658Z",
    transform: "translate(-2948.633 -2036.658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(0.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M2940.286,2036.658a.639.639,0,1,1-.548.633A.6.6,0,0,1,2940.286,2036.658Z",
    transform: "translate(-2939.739 -2036.658)",
    fill: "#fff"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(3.892 2.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M2948.459,2046.352a.382.382,0,1,1-.327.378A.356.356,0,0,1,2948.459,2046.352Z",
    transform: "translate(-2948.132 -2046.352)"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M3378.219,1602.8h.728a1.81,1.81,0,0,0,.93-.253,41.739,41.739,0,0,1,7.117-3.293s1.345-.365,8.241-.365c6,0,6.738,0,9.546.344,3.224.4-2.56,4.258-2.56,4.258s-13.217,1.251-11.076,8.236l-11.158-.007-4.463-.866a4.5,4.5,0,0,1-.829-3.028,1.394,1.394,0,0,1,.274-.869,1.887,1.887,0,0,0,.408-1.113C3375.378,1603.316,3375.134,1602.8,3378.219,1602.8Z",
    transform: "translate(-3374.695 -1598.891)",
    fill: "#bcbec0"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(0.711 0.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M3930.931,1989.666l4.462.866,11.159.007a4.467,4.467,0,0,1-.072-2.616h-11.05c-2.89,0-5.137,1.087-4.511,1.73Z",
    transform: "translate(-3930.813 -1977.828)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M2769.562,1607.5h2.68a2.086,2.086,0,0,0,1.307-.464,18.163,18.163,0,0,1,5.377-3.083,24.746,24.746,0,0,1,3.8-.238,23.3,23.3,0,0,1,5.03.328c3.155.778,7.989,4.147,7.989,4.147s6.35.73,7.7,4.3c.106.28.61.2.61.417,0,2.649-.851,3.536-1.059,3.536l-1.161,0c.014-.18.02-.362.02-.545,0-2.652-1.39-4-3.1-4s-3.1,1.344-3.1,4c0,.181.007.361.021.54l-15.992-.012c.012-.175.02-.351.02-.528,0-2.652-1.391-4-3.1-4s-3.1,1.344-3.1,4c0,.175.006.349.018.521l-4.462-.866a4.5,4.5,0,0,1-.829-3.029,1.391,1.391,0,0,1,.275-.869,1.885,1.885,0,0,0,.407-1.112C2768.9,1608.628,2768.767,1607.5,2769.562,1607.5Z",
    transform: "translate(-2757.774 -1603.717)",
    fill: "#a7a9ac"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M2816.177,1899.683a5.224,5.224,0,0,0,.041-.633c0-.059.062-.175.244-.175h.49c.587,0,1.141-2.457.456-2.457h-.946a2.028,2.028,0,0,1-1.482-.676,3.32,3.32,0,0,0-5.016,0,2.031,2.031,0,0,1-1.483.676h-14.136a2.033,2.033,0,0,1-1.484-.676,3.319,3.319,0,0,0-5.015,0,2.032,2.032,0,0,1-1.483.676h-15.214c-.168,0-.021,1.4.118,1.4,11.854,0,11.264.172,11.791.44a9.081,9.081,0,0,0,2.961.615c.388,0,.53.383.586.658l.646.126c-.011-.173-.018-.346-.018-.521,0-2.652,1.39-4,3.1-4s3.1,1.344,3.1,4c0,.177-.007.354-.019.528h.64a9.782,9.782,0,0,0-.052-1.606c0-.338,5.472-.614,5.757-.614h3.465c.283,0,5.58.276,5.58.614,0,0-.058,1.219-.043,1.617h.645c-.012-.178-.019-.359-.019-.54,0-2.652,1.389-4,3.1-4s3.1,1.344,3.1,4c0,.183-.008.365-.02.545Z",
    transform: "translate(-2770.8 -1886.828)",
    fill: "#bcbec0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M3978.044,2055.439h-10.012a5.673,5.673,0,0,1-2.229-.456l-1.458-.622c-.067-.029.214-.145.989-.145h6.733a7.77,7.77,0,0,1,1.62.171l2.265.483A13.657,13.657,0,0,1,3978.044,2055.439Z",
    transform: "translate(-3962.512 -2042.253)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(0.076 0.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M2846.568,1611.494c-2.022-2.711-7.149-3.3-7.149-3.3s-4.834-3.368-7.99-4.147a23.254,23.254,0,0,0-5.029-.329,24.677,24.677,0,0,0-3.8.238,18.136,18.136,0,0,0-5.378,3.083,2.089,2.089,0,0,1-1.308.463h-2.678c-.6,0-.67.64-.667,1.774C2831.121,1609.311,2841.356,1610.393,2846.568,1611.494Z",
    transform: "translate(-2800.81 -1603.718)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M4035.933,1805.612h0a.921.921,0,0,1-.922.921h-3.786a.921.921,0,0,1-.922-.921h0a1.591,1.591,0,0,0-1.592-1.591h-1.143c-.028.408-.012.921-.012,1.565a1.887,1.887,0,0,1-.408,1.113,1.362,1.362,0,0,0-.2.378h10.971a2.909,2.909,0,0,0,2.878-3.055h-3.274A1.591,1.591,0,0,0,4035.933,1805.612Z",
    transform: "translate(-4026.95 -1798.758)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M2773.6,1911.711c-.14-.09-.461-.092-.544-.309a3.908,3.908,0,0,0-.355-.71h-1.948C2771.052,1911.21,2771.872,1911.6,2773.6,1911.711Z",
    transform: "translate(-2726.745 -1902.626)",
    fill: "#e6e7e8"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(0.833 0.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M2888.367,1610.285a14.65,14.65,0,0,0-5.883-2.092s-4.834-3.368-7.989-4.147a23.268,23.268,0,0,0-5.03-.329,24.687,24.687,0,0,0-3.8.238,17.768,17.768,0,0,0-4.9,2.713C2872.764,1606.84,2883.027,1608.532,2888.367,1610.285Z",
    transform: "translate(-2844.632 -1603.718)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M4102.119,1726.482a.644.644,0,0,0,.612-.407c.263-.721,5.568.21,5.568-.965h-6.313c-.2.113-.393.226-.586.342a1.81,1.81,0,0,1-.93.253h-.728c-1.755,0-2.434.167-2.691.778Z",
    transform: "translate(-4097.05 -1721.921)",
    fill: "#e6e7e8"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(43.647 7.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M2793.775,1880.088l-.011-.023a4.4,4.4,0,0,0-1.038-1.556h-1.464c-.231,0-.327.41-.14.6a4.913,4.913,0,0,0,2.549.981Z",
    transform: "translate(-2791.023 -1878.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M2794.082,1879.975h-1.4c-.22,0-.319.364-.142.53a5.326,5.326,0,0,0,2.515.924A4.374,4.374,0,0,0,2794.082,1879.975Z",
    transform: "translate(-2792.342 -1879.936)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(0.589 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M2821.155,1895.034a2.773,2.773,0,0,1-1.284-.5c-.1-.09-.042-.287.076-.287h.245a1.047,1.047,0,0,1,1.029.656C2821.247,1894.967,2821.209,1895.041,2821.155,1895.034Z",
    transform: "translate(-2819.823 -1894.007)",
    fill: "#f7941d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M2810.769,1885.875a2.941,2.941,0,0,1-1.382-.55c-.1-.1-.045-.319.081-.319h.264a1.127,1.127,0,0,1,1.107.726C2810.867,1885.8,2810.828,1885.882,2810.769,1885.875Z",
    transform: "translate(-2809.166 -1885.006)",
    fill: "#fff"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M3784.328,1615.69h-8.321a41.5,41.5,0,0,0-6.9,3.216c-.052.031.131.081.428.081h8.994a2.327,2.327,0,0,0,1.432-.5,18.2,18.2,0,0,1,4.411-2.6C3784.469,1615.842,3784.9,1615.69,3784.328,1615.69Z",
    transform: "translate(-3763.92 -1615.248)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(6.354 0.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M3816.879,1632.383h6.854a3.882,3.882,0,0,0,2.216-.7,17.707,17.707,0,0,1,3-1.69h-8.382a42.707,42.707,0,0,0-4.707,2.159C3815.747,1632.215,3815.921,1632.383,3816.879,1632.383Z",
    transform: "translate(-3815.828 -1629.771)",
    fill: "#709aa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M3093.585,1621.632a9.319,9.319,0,0,1,2.988-.235,22.063,22.063,0,0,1,5.208.373c2.49.673,6.1,3.053,7.534,4.146.114.086.053.288-.083.28l-19.276-1.232A9.278,9.278,0,0,1,3093.585,1621.632Z",
    transform: "translate(-3077.184 -1621.397)",
    fill: "#709aa3"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(6.354 0.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M3818.184,1632.383a15.248,15.248,0,0,1,6.07-1.257h2.556a17.334,17.334,0,0,1,2.136-1.13h-8.381a42.748,42.748,0,0,0-4.707,2.159c-.11.059.065.228,1.023.228Z",
    transform: "translate(-3815.829 -1629.771)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M3094.411,1623.073a8.082,8.082,0,0,1,2.99-.274,19.014,19.014,0,0,1,5.207.434,20.229,20.229,0,0,1,5.054,2.862l1.57.1c.137.009.2-.193.083-.28-1.434-1.093-5.044-3.473-7.534-4.146a22.056,22.056,0,0,0-5.208-.373,6.1,6.1,0,0,0-6.618,3.567l2.091.134A11.076,11.076,0,0,1,3094.411,1623.073Z",
    transform: "translate(-3077.184 -1621.397)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(19.074 0.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(0.884 4.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(8.888 0.304)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 0.59,
    cy: 0.413,
    rx: 0.59,
    ry: 0.413,
    transform: "translate(0.226)",
    fill: "#939598",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(0 0.18)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M3403.812,1822.516h-1.02a.233.233,0,0,1-.233-.233h0a.233.233,0,0,1,.233-.233h1.02a.233.233,0,0,1,.233.233h0A.233.233,0,0,1,3403.812,1822.516Z",
    transform: "translate(-3402.559 -1822.05)",
    fill: "#939598"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(0.146 0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M3398.26,1822.516h-1.019a.233.233,0,0,1-.233-.233h0a.233.233,0,0,1,.233-.233h1.019a.233.233,0,0,1,.233.233h0A.233.233,0,0,1,3398.26,1822.516Z",
    transform: "translate(-3397.008 -1822.05)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 0.59,
    cy: 0.413,
    rx: 0.59,
    ry: 0.413,
    transform: "translate(0.226)",
    fill: "#939598",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(0 0.18)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M3742.077,1810.933h-1.02a.234.234,0,0,1-.233-.233h0a.233.233,0,0,1,.233-.233h1.02a.233.233,0,0,1,.233.233h0A.233.233,0,0,1,3742.077,1810.933Z",
    transform: "translate(-3740.824 -1810.467)",
    fill: "#939598"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0.146 0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M3736.526,1810.933h-1.02a.233.233,0,0,1-.232-.233h0a.233.233,0,0,1,.232-.233h1.02a.233.233,0,0,1,.233.233h0A.234.234,0,0,1,3736.526,1810.933Z",
    transform: "translate(-3735.274 -1810.467)",
    fill: "#fff"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M3107.95,1624.651a.173.173,0,0,1-.161.118h-.01l-19.326-1.235.015-.048a9.234,9.234,0,0,1,3.648-3.355h0a9.249,9.249,0,0,1,3.006-.239,22.543,22.543,0,0,1,5.218.374,27.945,27.945,0,0,1,7.548,4.153A.2.2,0,0,1,3107.95,1624.651Zm-16.432-1.277c-.115-.727-.256-1.456-.43-2.171a11.582,11.582,0,0,0-1.6,1.433.374.374,0,0,0,.253.625Zm.162.01,5.456.349a25.074,25.074,0,0,0-.755-3.472c-.384-.008-.8-.013-1.258-.013a10.54,10.54,0,0,0-2.856.206,8.643,8.643,0,0,0-1.041.648C3091.412,1621.852,3091.56,1622.62,3091.68,1623.383Zm14.053.9a1.68,1.68,0,0,0-.8-1.434,20.287,20.287,0,0,0-4.684-2.239,13.9,13.9,0,0,0-2.7-.308,27.433,27.433,0,0,1,.723,3.5Z",
    transform: "translate(-3088.453 -1619.891)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M3133.483,1631.457c1.126-4.955-.062-7.85-.074-7.879a.042.042,0,0,0-.014-.017,26.325,26.325,0,0,0-6.348-3.3,22.541,22.541,0,0,0-5.217-.374,6.137,6.137,0,0,0-6.656,3.595.037.037,0,0,0,0,.018l.257,1.469a2.119,2.119,0,0,0,.827,1.367c2.407,1.682,2.8,2.935,3.122,3.941a5.258,5.258,0,0,0,.373.96,1,1,0,0,0,.871.553H3133.1A.409.409,0,0,0,3133.483,1631.457Zm-14.626-11.255a9.652,9.652,0,0,1,2.972-.231,22.575,22.575,0,0,1,5.2.371,26.2,26.2,0,0,1,6.314,3.277c.077.2,1.151,3.042.065,7.821a.33.33,0,0,1-.307.276h-12.477a.921.921,0,0,1-.8-.512,5.2,5.2,0,0,1-.368-.946c-.322-1.018-.723-2.284-3.152-3.982a2.033,2.033,0,0,1-.793-1.316l-.255-1.46A9.383,9.383,0,0,1,3118.857,1620.2Z",
    transform: "translate(-3115.171 -1619.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M3462.806,1632.733h0a.039.039,0,0,1-.037-.042,39.524,39.524,0,0,0-1.211-11.771.041.041,0,0,1,.027-.05.038.038,0,0,1,.048.026,39.591,39.591,0,0,1,1.215,11.8A.039.039,0,0,1,3462.806,1632.733Z",
    transform: "translate(-3453.19 -1620.843)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(17.506 3.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M3061.265,1781.013a.937.937,0,0,0-.343-.6l-.466-.38a2.254,2.254,0,0,0-.74-.427c-.385-.116-.668,0-.771.325l-.407-.332c-.036-.03-.066-.026-.066.009v.248a.184.184,0,0,0,.066.117l1.736,1.416c.027.022.05.026.061.012l.2.162c.4.33.731.288.731-.094v-.355h0Z",
    transform: "translate(-3058.472 -1778.409)",
    fill: "#939598",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    d: "M.063,0H1.207a.31.31,0,0,1,.31.31v0a.063.063,0,0,1-.063.063H.063A.063.063,0,0,1,0,.31V.063A.063.063,0,0,1,.063,0Z",
    transform: "translate(0 1.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    d: "M1.466,0h.653a.323.323,0,0,1,.323.323V.775a.69.69,0,0,1-.69.69H0a0,0,0,0,1,0,0v0A1.466,1.466,0,0,1,1.466,0Z",
    transform: "translate(0.35 0)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M3060.052,1736.192h.862v-.1a.3.3,0,0,0-.278-.323h-.9a1.375,1.375,0,0,0-1.261,1.466h.139A1.6,1.6,0,0,1,3060.052,1736.192Z",
    transform: "translate(-3058.122 -1735.772)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(0.564 0.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M3076.988,1741.411h-1.1a.138.138,0,0,1-.138-.138h0a1,1,0,0,1,1.145-1.145h.49a.139.139,0,0,1,.139.14v.6A.539.539,0,0,1,3076.988,1741.411Z",
    transform: "translate(-3075.753 -1740.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    d: "M1.113,0h.45a.177.177,0,0,1,.177.177V.723a.524.524,0,0,1-.524.524H.134A.134.134,0,0,1,0,1.113v0A1.113,1.113,0,0,1,1.113,0Z",
    transform: "translate(0.035 0.035)",
    fill: "#00a79d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M3078.236,1741.469h-.156a1.093,1.093,0,0,0-1.094,1.094v.021a.117.117,0,0,0,.008.039,2.443,2.443,0,0,1,1.7-.836A.488.488,0,0,0,3078.236,1741.469Z",
    transform: "translate(-3076.952 -1741.433)",
    fill: "#fff",
    opacity: 0.5
  })))))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 8.529,
    height: 1.069,
    transform: "translate(2.232 5.441)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(0.587 5.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(8.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M4023.231,1795.329h-3.248a1.274,1.274,0,0,0-1.273,1.274v.377a.129.129,0,0,0,.13.129h2.729a1.623,1.623,0,0,0,1.395-.878l.376-.669A.152.152,0,0,0,4023.231,1795.329Z",
    transform: "translate(-4018.67 -1795.289)",
    fill: "#e42125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M4021,1795.329a.153.153,0,0,1,.108.233l-.376.669a1.622,1.622,0,0,1-1.395.878h-.5a3.072,3.072,0,0,1,0-1.781Z",
    transform: "translate(-4016.441 -1795.289)",
    fill: "#be1e2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(2.359 0.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M4047.558,1813.072a.1.1,0,0,1,.071.155l-.251.446a1.081,1.081,0,0,1-.929.585h0a.454.454,0,0,1-.418-.47c0-.041,0-.081,0-.123v-.007a.552.552,0,0,1,.507-.587Z",
    transform: "translate(-4046.03 -1812.686)",
    fill: "#e42125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M4047.132,1798.4a.074.074,0,0,1,.053.113l-.182.323a.782.782,0,0,1-.672.423h0a.327.327,0,0,1-.3-.34c0-.029,0-.059,0-.089v0a.4.4,0,0,1,.366-.425Z",
    transform: "translate(-4045.581 -1798.396)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M4021.528,1794.785l.376-.669a.209.209,0,0,0,0-.207.166.166,0,0,0-.141-.085h-3.248a1.315,1.315,0,0,0-1.314,1.313v.377a.169.169,0,0,0,.169.169h2.729A1.656,1.656,0,0,0,4021.528,1794.785Zm.234-.882a.085.085,0,0,1,.072.046.127.127,0,0,1,0,.128l-.376.669a1.578,1.578,0,0,1-1.359.858h-2.729a.091.091,0,0,1-.09-.09v-.377a1.236,1.236,0,0,1,1.235-1.234Z",
    transform: "translate(-4017.2 -1793.824)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(0.214 0.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 1.732,
    height: 0.905,
    rx: 0.452,
    transform: "translate(0 0.566)",
    fill: "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M4114.234,1802.571h-.7a.386.386,0,0,1-.385-.384h0a.386.386,0,0,1,.385-.384h.7a.385.385,0,0,1,.385.384h0A.385.385,0,0,1,4114.234,1802.571Z",
    transform: "translate(-4112.624 -1801.803)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M4440.384,1795.329h-1.093c-.195,0-.168,1.781-.035,1.781h2.271a.13.13,0,0,0,.13-.13v-.377A1.274,1.274,0,0,0,4440.384,1795.329Z",
    transform: "translate(-4439.15 -1795.289)",
    fill: "#e42125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(0.174 0.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 1.732,
    height: 0.905,
    rx: 0.452,
    transform: "translate(0.263 0.566)",
    fill: "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M4472.3,1802.571h.7a.385.385,0,0,0,.385-.384h0a.385.385,0,0,0-.385-.384h-.7a.386.386,0,0,0-.384.384h0A.386.386,0,0,0,4472.3,1802.571Z",
    transform: "translate(-4471.915 -1801.803)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M4440,1795.683h-2.317a.039.039,0,0,1,0-.079H4440a.09.09,0,0,0,.089-.09v-.377a1.235,1.235,0,0,0-1.233-1.234h-1.139a.04.04,0,1,1,0-.079h1.139a1.315,1.315,0,0,1,1.313,1.313v.377A.17.17,0,0,1,4440,1795.683Z",
    transform: "translate(-4437.626 -1793.824)"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M4207.833,1815.332h-5.488a.307.307,0,0,1-.307-.307h0a.307.307,0,0,1,.307-.307h5.488a.308.308,0,0,1,.308.307h0A.307.307,0,0,1,4207.833,1815.332Z",
    transform: "translate(-4198.816 -1809.047)",
    fill: "#e42125"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M4159.59,1748.388a.991.991,0,0,0-.36.764v2.422a1.015,1.015,0,0,1-1.015,1.015h-5.849a1.016,1.016,0,0,1-1.016-1.015v-2.422a.915.915,0,0,1,.426-.772l-.146.008a.992.992,0,0,0-.36.764v2.422a1.1,1.1,0,0,0,1.1,1.094h5.849a1.1,1.1,0,0,0,1.095-1.094v-2.422a.914.914,0,0,1,.426-.772Z",
    transform: "translate(-4149.078 -1744.452)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarThumbnail);
export default __webpack_public_path__ + "static/media/car-thumbnail.2080b51c936ef4a330029b99459c3a0f.svg";
export { ForwardRef as ReactComponent };